import { analytics } from '../firebase/config';
import { logEvent } from 'firebase/analytics';

// Helper function to safely log events
const safeLogEvent = (eventName, eventParams) => {
  if (analytics) {
    logEvent(analytics, eventName, eventParams);
  }
};

// Track page views
export const trackPageView = (pageName) => {
  safeLogEvent('page_view', {
    page_title: pageName,
    page_location: window.location.href,
    page_path: window.location.pathname
  });
};

// Track user actions
export const trackUserAction = (actionName, actionData = {}) => {
  safeLogEvent(actionName, actionData);
};

// Track errors
export const trackError = (error, errorInfo = {}) => {
  safeLogEvent('error', {
    error_message: error.message,
    error_stack: error.stack,
    ...errorInfo
  });
};

// Track form submissions
export const trackFormSubmission = (formName, success, error = null) => {
  safeLogEvent('form_submission', {
    form_name: formName,
    success,
    error_message: error?.message
  });
};

// Track feature usage
export const trackFeatureUsage = (featureName, usageData = {}) => {
  safeLogEvent('feature_usage', {
    feature_name: featureName,
    ...usageData
  });
}; 